<template>
  <q-dialog v-model="confirm" persistent>
    <q-card
      class="column col-6"
      :style="{
        'min-height': height === '' ? '300px' : height,
        'max-height': height === '' ? '300px' : height,
        width: '500px',
      }"
    >
      <q-card-section class="column">
        <span style="color: #21324a" class="mensagem-text">{{ mensagem }}</span>
        <q-separator style="height: 1px; background-color: #21324a" />
      </q-card-section>

      <section style="color: #21324a; padding: 0px 17px">
        {{ subMensagem }}
      </section>

      <q-card-section
        style="min-height: 176px; max-height: 150px; overflow-y: scroll"
      >
        <slot></slot>
      </q-card-section>

      <q-card-actions class="row col-12 justify-end" align="right">
        <q-btn
          label="Confirmar"
          :disabled="desabilitarConfirme"
          no-caps
          class="q-mt-sm"
          icon="done"
          v-close-popup
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          @click="$emit('resultado', true)"
        />
        <q-btn
          v-if="showCancelar"
          icon="close"
          no-caps
          label="Cancelar"
          v-close-popup
          style="
            background-color: white;
            border-radius: 8px;
            color: #21324a;
            font-weight: normal;
            border: 1px solid #21324a;
          "
          @click="$emit('resultado', false)"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { watch, ref } from "vue";
export default {
  props: [
    "mensagem",
    "exibir",
    "desabilitarConfirme",
    "subMensagem",
    "showCancelar",
    "height",
    "width",
  ],
  setup(props) {
    const confirm = ref(false);

    watch(
      () => props.exibir,
      () => {
        confirm.value = props.exibir;
      }
    );
    return {
      confirm,
    };
  },
};
</script>

<style scoped>
.mensagem-text {
  font-weight: bold;
  font-size: 18px;
}
</style>
